import { io } from "socket.io-client";
const socketServerURL =
  process.env.REACT_APP_API_URL_FOR_SOCKET || "https://api.netwala.app";
export const socket = io(socketServerURL);
